import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { motion } from "framer-motion";

const SaveSearchCardSkeleton = () => {
  return (
    <motion.div
      className="flex w-full items-center flex-col md:flex-row h-full"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <Skeleton
        width={"245px"}
        height="243px"
        borderRadius={18}
        baseColor="#ddd"
        highlightColor="#e8e8e8"
        duration={1.6}
      />
      <div className="w-full lg:w-[338px] md:ml-[32px]">
        <Skeleton
          height={30}
          width={"100%"}
          borderRadius={6}
          baseColor="#ddd"
          highlightColor="#e8e8e8"
          duration={1}
        />
        <Skeleton
          height={20}
          width={"70%"}
          className="mt-[16px]"
          borderRadius={6}
          baseColor="#ddd"
          highlightColor="#e8e8e8"
          duration={1}
        />

        <Skeleton
          width={"100%"}
          height={25}
          className="mt-[10px]"
          borderRadius={6}
          baseColor="#ddd"
          highlightColor="#e8e8e8"
          duration={1}
        />
        <Skeleton
          width={200}
          height={40}
          className="mt-8"
          borderRadius={6}
          baseColor="#ddd"
          highlightColor="#e8e8e8"
          duration={1}
        />
      </div>
    </motion.div>
  );
};

export default SaveSearchCardSkeleton;
